import * as TYPES from './type';
export default {
  //预习任务
  [TYPES.SCHOOL_OVERVIEW](state, { result }) {
    state.schoolOverview = result.result
  },
  [TYPES.COURSEWARE_RESOURCE](state, { result }) {
    state.coursewareResource = result.result
  },
  [TYPES.ACTIVITY_PROPORTOPN](state, { result }) {
    state.activityProportopn = result.result
  },
  [TYPES.ATTENDANCE](state, { result }) {
    state.attendance = result.result
  },
  [TYPES.ACHIEVEMENT_ANALYSIS](state, { result }) {
    state.achievementAnalysis = result.result
  },
  [TYPES.DEPARTMENT_RESOURCE](state, { result }) {
    state.departmentResource = result.result
  },
  [TYPES.DEPARTMENT_RESOURCE_DETAILS](state, { result }) {
    state.departmentResourceDetails = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/situation/mutations.js